import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const RegisterMemberBlock = ({
  gift,
  scriptUrl,
  stylesheetUrl,
  apiBaseUrl,
  criiptoDomain,
  criiptoClientId,
  criiptoScope,
  recaptchaSiteKey,
  memberSignupNotifyUrl
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined;
    }

    const element = containerRef.current;
    let isCancelled = false;

    // The stylesheet is injected into the form's shadow root by mount() (not as a
    // global <link>), so the host page's CSS and the form's CSS stay isolated.
    const mountApp = () => {
      if (isCancelled || !window.MemberRegistration || !element) {
        return;
      }

      window.MemberRegistration.mount(element, {
        gift,
        apiBaseUrl,
        criiptoDomain,
        criiptoClientId,
        criiptoScope,
        stylesheetUrl,
        recaptchaSiteKey,
        memberSignupNotifyUrl,
        redirectUri: window.location.href
      });
    };

    let script = document.querySelector(`script[src="${scriptUrl}"]`);

    if (window.MemberRegistration) {
      mountApp();
    } else if (script) {
      script.addEventListener('load', mountApp);
    } else {
      script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.addEventListener('load', mountApp);
      document.body.appendChild(script);
    }

    return () => {
      isCancelled = true;

      if (script) {
        script.removeEventListener('load', mountApp);
      }

      if (window.MemberRegistration && element) {
        window.MemberRegistration.unmount(element);
      }
    };
  }, [gift, scriptUrl, stylesheetUrl, apiBaseUrl, criiptoDomain, criiptoClientId, criiptoScope, recaptchaSiteKey, memberSignupNotifyUrl]);

  return <div className="register-member-block" ref={containerRef} />;
};

RegisterMemberBlock.propTypes = {
  gift: PropTypes.bool,
  scriptUrl: PropTypes.string,
  stylesheetUrl: PropTypes.string,
  apiBaseUrl: PropTypes.string,
  criiptoDomain: PropTypes.string,
  criiptoClientId: PropTypes.string,
  criiptoScope: PropTypes.string,
  recaptchaSiteKey: PropTypes.string,
  memberSignupNotifyUrl: PropTypes.string
};

export default RegisterMemberBlock;
